import { swiperOptions } from "./main-includes/swiper-options";

(function($) { "use strict";


	//Check we are on a page containing filters
	if( $('.filters').length ) {
		var developmentSwiper;

		// **
		// ** Filters 
		// **


		// Function which will be used when filters are rendered to help prevent popups from overflowing the viewport
		function checkElementPositions() {
			$('.wpgb-button-facet, .wpgb-range-facet').each(function() {
				var element = $(this);
				var elementLeft = element.offset().left;
				var elementRight = elementLeft + element.outerWidth();
				var viewportRight = $(window).width();
				
				if (elementRight > viewportRight) {
					element.addClass('position-to-the-right');
				} else {
					element.removeClass('position-to-the-right');
				}
				// console.log('elementRight:' + elementRight);
				// console.log('viewportRight:' + viewportRight);
			});


		}



		// Show button facet popups when their filters are clicked upon.
		$('.wpgb-facet').on('click', function(){

			// Check if the one clicked on is already open
			if ( $( this ).hasClass( "js-active" ) ) {

				// Hide all opened facet popups 
				$('.wpgb-facet').removeClass('js-active');
			
			} else {

				// Hide any previously opened facet popups 
				$('.wpgb-facet').removeClass('js-active');
				// Open this one
				$(this).addClass('js-active');

			}
		});


		// Hide all button facet popups when the user clicks outside of them.
		$(document).on('click', function(){
			$('.wpgb-facet').removeClass('js-active');
		});

		$('.wpgb-facet').on('click', function(e){
			e.stopPropagation();
		});

		// **
		// ** When a grid/template/content is initialized. 
		// **
		window.WP_Grid_Builder && WP_Grid_Builder.on( 'init', function( wpgb ) {


			// Take the value selected from our constructed dropdown and update the Geo facet
			$('#radius-select').change(function() {

				var selectedValue = $(this).val(); // Value select by user

				// Check if we are on Development or Properties page
				if ($('body').hasClass('page-developments')) {
					var facetSlug = 'development_geolocation';
				} else if ($('body').hasClass('page-properties')) {
					var facetSlug = 'property_geolocation';
				} else if ($('body').hasClass('page-bungalows')) {
					var facetSlug = 'bungalows_geolocation';
				}
	
				var props = wpgb.facets.getFacet( facetSlug ); // Get facet's properties
				var params = wpgb.facets.getParams( facetSlug ); // Get facet's parameters (selected values)
				
				props[0].radius = selectedValue; // Update the 'default radius' to be the selected value (Useful in case the radius is changed before any location has been set)

				// Copy the selected value to the plugin's radius input (which will be hidden from the user)
				var inputElement = $('.wpgb-geo-radius').find('input[type="number"]');
      			inputElement.val(selectedValue);

				// Only update the params if a location is set
				if (Object.keys(params).length !== 0) {
					params[2] = selectedValue;
					wpgb.facets.setParams( facetSlug, params );
					wpgb.facets.refresh();
				}

			});


			// console.dir( wpgb ); // Holds all instances.

			// **
			// ** Map
			// **

			// Hide/Show relevant side panels when markers are clicked upon.
			wpgb.facets.on( 'map.marker.click', function( instance, feature ) {

				let development_id = feature.properties.id;

				instance.map.setFilter("marker-hover", ["==", "id", development_id]);
				if(!$('body').hasClass('page-bungalows')) {
					instance.map.setFilter("all-developments-hover-layer", ["==", "id", development_id]);
				}

				// alert('map.marker.click');
				// alert('cippalippa');
				// console.log('cippalippa');
				// console.log(instance);
				// console.log(feature);
				// debugger;

				//Hide the instructions
				$('.detail__instructions').hide();

				const selector = '.section-developments .map-view .detail__panel[data-development-id="'+development_id+'"]';
				const swiperSelector = `${selector} .swiper_container`;
				$('.section-developments .map-view .detail__panel').removeClass('js-active');
				$(selector).addClass('js-active');
				if(developmentSwiper) {
					developmentSwiper.destroy();
					developmentSwiper = undefined;
				}
				if($(swiperSelector).length) {
					developmentSwiper = new Swiper(swiperSelector, swiperOptions);
				}
			} );

			//Load additional marker layer to keep all markers visible while filtering
			wpgb.facets.on("map.marker.loaded", function (instance) {
				// console.log('map.loaded');
				if(!$('body').hasClass('page-bungalows')) {
					if (instance.map.getSource('all-developments-source')) {
						//source already loaded
					} else {

						instance.map.addSource('all-developments-source', {
							type: "geojson",
							data: wpgb_settings.twotone_all_developments_markers, //GeoJSON format, analogous to instance.map.getSource('markers')._data,
							cluster: false
						});

						//load image, and on callback use image to load development markers
						instance.map.loadImage(
							wpgb_settings.twotone_all_developments_markers_icon, // '/wp-content/themes/riceandroman/assets/img/icons/marker-all.png',
							(error, image) => {
								if (error) throw error;

								//image loaded. add it to the map
								instance.map.addImage('all-developments-icon',image);

								//derive icon size mimicking the default behaviour from /wp-content/plugins/wp-grid-builder-map-facet/assets/js/map.js
								let  icon_size = instance.facet.settings.map_marker_icon ?
									(instance.facet.settings.map_marker_height || 40) / instance.facet.settings.map_marker_icon[2] :
									(instance.facet.settings.map_marker_height || 40) / 86
								;

								//add new layer. the second parameter specifies that this layer goes before it in z-index
								instance.map.addLayer({
									id: "all-developments-layer",
									type: "symbol",
									// filter: ["!has", "point_count"],
									source: "all-developments-source",
									layout: {
										"icon-image": "all-developments-icon",
										"icon-size": icon_size, //same size as the normal marker
										"icon-offset": [0, 0],
										"icon-anchor": "bottom",
										"icon-allow-overlap": !0
									}
								},
									instance.map.getLayer('marker') ? 'marker' : null //the new layer will be behind the 'markers' one, if present.
								);



								//add YET ANOTHER new layer for the hover markers. this one should sit on top of everything, and filtered to only show the currently clicked marker
								instance.map.addLayer({
										id: "all-developments-hover-layer",
										type: "symbol",
										filter: ["==", "id", ""],
										source: "all-developments-source",
										layout: {
											"icon-image": "hover",
											"icon-size": icon_size, //same size as the normal marker
											"icon-offset": [0, 0],
											"icon-anchor": "bottom",
											"icon-allow-overlap": !0
										}
									},
									null //the new layer should be on the top.
								);


								//clicks on this new layer items do the same as clicks on the normal marker layer
								instance.map.on('click', 'all-developments-layer', (e) => {

									let feature = e.features[0];
									let development_id = e.features[0].properties.id;

									// console.log('clicked on all-developments-layer for development ', development_id);
									//same instructions as for normal marker click

									instance.map.setFilter("marker-hover", ["==", "id", development_id]);
									instance.map.setFilter("all-developments-hover-layer", ["==", "id", development_id]);

									//Hide the instructions
									$('.detail__instructions').hide();

									const selector = '.section-developments .map-view .detail__panel[data-development-id="'+development_id+'"]';
									const swiperSelector = `${selector} .swiper_container`;
									$('.section-developments .map-view .detail__panel').removeClass('js-active');
									$(selector).addClass('js-active');
									if(developmentSwiper) {
										developmentSwiper.destroy();
										developmentSwiper = undefined;
									}
									if($(swiperSelector).length) {
										developmentSwiper = new Swiper(swiperSelector, swiperOptions);
									}
								});

								// Change the cursor to a pointer when the mouse is over the developement layer.
								instance.map.on('mouseenter', 'all-developments-layer', () => {
									instance.map.getCanvas().style.cursor = 'pointer';
								});

								// Change it back to a pointer when it leaves.
								instance.map.on('mouseleave', 'all-developments-layer', () => {
									instance.map.getCanvas().style.cursor = '';
								});

							}
						);
					}
				} else {
					// Retrieve the GeoJSON features (markers) from the map instance
					const features = instance.map.getSource('markers')._data.features;

					// Check if there are any features (markers) present
					if (features.length > 0) {
						let bounds = new mapboxgl.LngLatBounds(); // Initialize bounds object to encompass all marker coordinates
						
						features.forEach(feature => { // Extend bounds to include all feature coordinates
							bounds.extend(feature.geometry.coordinates);
						});
				
						// Get the current dimensions of the map container
						const mapHeight = instance.map.getContainer().clientHeight;
						const mapWidth = instance.map.getContainer().clientWidth;
				
						// Define padding for the map to fit inside the Bounds
						const padding = {
							top: mapHeight * 0.05,
							bottom: mapHeight * 0.05,
							left: mapWidth * 0.05,
							right: mapWidth * 0.05
						};
				
						// Fit the map to the calculated bounds with dynamic padding
						instance.map.fitBounds(bounds, { padding });
					}
				}
			} );

			// **
			// ** Other filters
			// **

			// When a filter is applied and all the facets loaded.
			wpgb.facets.on( 'loaded', function( facets ) {

				// Check positions of filter popups and alter them if they overflow the viewport
				checkElementPositions();
	
				$(window).on('resize', function() {
				  checkElementPositions();
				});

				// Close all the popups
				$('.wpgb-facet').removeClass('js-active');

				// Scroll to page top
				window.scrollTo(0, 0);


			} );



			//Check we are on a page containing a grid
			if( $('.wp-grid-builder').length ) {
				// This event is triggered after grid items are laid out.
				wpgb.grid.on( 'layout', function( items ) {

					// Target and hide Property status if the status if 'Available'
					$('.wpgb-card-footer .status:contains("Available")').hide();

				
				} );
			}


			// Whenever a filter is applied, each filter gets re-rendered - Show selected values underneath.
			wpgb.facets.on( 'render', function( element, facet ) {

				// For range slider filters
				if (facet.type == 'range') {				

					// Grab the values
					var selected_values = $(element).find('.wpgb-range-values').text(); 

					// Set the container
					var $selected_values_container = $(element).find('.facet_show_values');
					if ($selected_values_container.length == 0) {
						$(element).append('<div class="facet_show_values"></div>');
						$selected_values_container = $(element).find('.facet_show_values');
					}

					// Display the values, or clear them if none were selected
					if(wpgb.facets.hasParams( facet.slug )) {
						$selected_values_container.html(selected_values);
					} else {
						$selected_values_container.html('All');
					}	
					
				}

				// For button filters
				if (facet.type == 'button') {	

					//Prepare the values array
					var selected_values = [];

					// Loop the pressed ones
					$(element).find('.wpgb-button[aria-pressed="true"]').each(function(){

						// Exclude the 'All' buttons which have no value set
						if ($(this).find('input').val() != '') {

							// Get only the text node, ignore sub elements (eg. <spans>)
							var text = $(this)
								.find('.wpgb-button-label')
								.contents()
								.filter(function(){ return this.nodeType == 3; })
							;

							// Add found values to the array
							if (text.length) {
								selected_values.push(text[0].nodeValue.trim());
							}

						}

					});
				
					// Set the container
					var $selected_values_container = $(element).find('.facet_show_values');
					if ($selected_values_container.length == 0) {
						$(element).append('<div class="facet_show_values"></div>');
						$selected_values_container = $(element).find('.facet_show_values');
					}


					if(wpgb.facets.hasParams( facet.slug )) {
						// Display the values
						$selected_values_container.html(selected_values.join(', '));
					} else {
						$selected_values_container.html('All');
					}
				}

				//reorder and group development list
				if (facet.slug == "property_development") {

					// console.log('facet', facet);
					// console.log('wpgb_settings.twotone_all_developments_areas', wpgb_settings.twotone_all_developments_areas);

					let $facet_ul = $('.wpgb-facet[data-facet='+facet.id+']').find('.wpgb-inline-list');

					//bail if the list has already areas
					if ($facet_ul.find('li.area').length == 0) {

						//get frontend list of li tags. at this stage, it contains only developments and the "All" entry.
						let $development_lis = $facet_ul.find('li');

						//find the "All" element
						let $all = $development_lis.has("input[value='']")

						//mark the "all" element with a class
						$all.addClass('all');

						//mark all development li elements with the class "development"
						$development_lis.not($all).addClass('development');

						//append new <li> elements with the areas
						let $after = $all; //$after keeps track of the element after which to instert new stuff

						let last_area = null; //areas in the array are repeated. this help avoiding duplicate areas

						wpgb_settings.twotone_all_developments_areas.forEach((development, index) => {
							if (last_area != development.area) {

								// console.log('development.api_id', development.api_id);

								//only add the area if the development is in the list
								if ($development_lis.has('input[value="'+development.api_id+'"]').length) {

									// console.log('development.api_id', development.api_id, 'found');
									//insert new element
									let $area_li = $('<li></li>')
										.addClass('area')
										.attr('area', development.area) //add the value as attribute to allow for search
										.css('color', 'white')
										.text(development.area)
										.insertAfter($after)
									;

									//update the $after variable
									$after = $area_li;

									last_area = development.area;
								} else {
									// console.log('development.api_id', development.api_id, 'NOT found');
								}

							}
						});

						//get a list of all recently-inserted areas
						let $area_lis = $facet_ul.find('li.area');

						//mark area li elements with class "area"
						$area_lis.addClass('area');

						// console.log('$area_lis', $area_lis);

						//find all development li and move them after the AREA li.
						wpgb_settings.twotone_all_developments_areas.forEach((development, index) => {

							const $development_li = $development_lis.has('input[value="'+development.api_id+'"]');

							if ($development_li.length) {

								//find the area li
								const $area_li = $area_lis.filter('[area="'+development.area+'"]');

								//move the development after the area li
								$development_li.insertAfter($area_li);
							}
						});

						//add a fake "No Development" area li
						$development_lis.has('input[value="0"]').before(
							$('<li></li>')
								.addClass('area')
								.attr('area', 'no-development') //add the value as attribute to allow for search
								.css('color', 'white')
								.text('No development')
						);
					}
				}

			} );


			// When setting cooperativeGestures to true, scroll-to-zoom requires using the 
			// control or command key while scrolling to zoom the map, and panning on touch 
			// devices requires using two fingers to pan the map.
			// wpgb.facets.on( 'map.beforeInit', function( instance ) {
				// instance.options.cooperativeGestures = true;
			// } );



			
			// **
			// ** View Switching
			// **

			if( $('.view-switcher').length ) {

				var view_switcher = document.getElementById('view-switcher')
				var map_view = document.getElementById('map-view')
				var list_view = document.getElementById('list-view')
				
				var buttonState = true;
					
				view_switcher.addEventListener('click', function() {
				if (buttonState) { // Switching to list view 

					// Move the button
					document.getElementById("button-element").style.transform = "translateX(120px)"; 
					buttonState = false;
					map_view.innerText = 'List view'
					list_view.innerText = 'Map view'
					list_view.style.transform = "translateX(-120px)";

					// Show / hide sections
					$('.section-developments .map-view').hide();
					$('.section-developments .list-view').show(); 

					// Refresh the grid layout
					wpgb.grid.layout();


				} else { // Switching to map view

					// Move the button
					document.getElementById("button-element").style.transform = "translateX(0px)";
					buttonState = true;
					map_view.innerText = 'Map view'
					list_view.innerText = 'List view'
					list_view.style.transform = "translateX(0px)";

					// Show / hide sections
					$('.section-developments .list-view').hide();
					$('.section-developments .map-view').css("display", "flex");

					// Refresh the grid layout
					window.dispatchEvent(new Event('resize'));

				}
					
				})


				// Showing list view by default on mobile
				var windowWidth = $(window).width();
			
				if (windowWidth < 1200) {

					// Show / hide sections
					$('.section-developments .map-view').hide();
					$('.section-developments .list-view').show(); 

					// Move the button
					document.getElementById("button-element").style.transform = "translateX(120px)"; 
					buttonState = false;
					map_view.innerText = 'List view'
					list_view.innerText = 'Map view'
					list_view.style.transform = "translateX(-120px)";

				}

			}

		

		} );


	}



})(jQuery);